module.exports = __webpack_public_path__ + "img/chevron_white_right_32px@2x.546cf560.png";